import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Container from 'layout/atoms/Container';
import ContentBox from 'layout/atoms/ContentBox';

import IllustrationExecute from 'assets/illustrations/empty-execute.webp';

export const EmptyState = () => {
    useEffect(() => {}, []);
    const { t } = useTranslation();

    return (
        <Container size="s" marginTop="16">
            <ContentBox>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        src={IllustrationExecute}
                        alt=""
                        style={{ maxWidth: '200px' }}
                    />
                    <h3
                        style={{
                            margin: '0 0 12px 0',
                            fontSize: '20px',
                            fontWeight: '600',
                            color: 'var(--text)',
                        }}
                    >
                        {t('EXECUTE.EMPTY_STATE.TITLE')}
                    </h3>
                    <p
                        style={{
                            margin: '0 0 24px 0',
                            fontSize: '16px',
                            lineHeight: '1.5',
                            color: 'var(--text)',
                            opacity: 0.7,
                            maxWidth: '400px',
                        }}
                    >
                        {t('EXECUTE.EMPTY_STATE.DESCRIPTION')}
                    </p>
                    <div
                        style={{
                            fontSize: '14px',
                            color: 'var(--text)',
                            opacity: 0.6,
                            fontWeight: '500',
                        }}
                    >
                        {t('EXECUTE.EMPTY_STATE.CTA')}
                    </div>
                </div>
            </ContentBox>
        </Container>
    );
};

export default EmptyState;
